import { ReactNode } from 'react'
import { SectionCard } from '@/components/common/SectionCard'

interface ConfigSectionProps {
  title: string
  description?: string
  children: ReactNode
  className?: string
  bodyClassName?: string
  action?: ReactNode
}

export function ConfigSection({ title, description, children, className, bodyClassName, action }: ConfigSectionProps) {
  return (
    <SectionCard title={title} description={description} action={action} className={className} bodyClassName={bodyClassName}>
      {children}
    </SectionCard>
  )
}
